export default __webpack_public_path__ + "static/media/app-store-hover.65a8884a.png";